if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection ? this.productSection.querySelector('.product-info') : null;
      this.productForm = this.productSection ? this.productSection.querySelector('product-form') : null;
      this.observer = null;

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      StickyAtcPanel.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      window.removeEventListener('resize', StickyAtcPanel.handleScroll);

      if (this.observer) {
        this.observer.disconnect();
      }
    }

    bindEvents() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const isDesktop = Boolean(window.theme && window.theme.mediaMatches && window.theme.mediaMatches.md);

          if (entry.target === this.productForm && !isDesktop) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          }

          if (entry.target === this.productInfo && isDesktop) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      }, {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -20px 0px'
      });

      if (this.productForm) {
        this.observer.observe(this.productForm);
      }

      if (this.productInfo) {
        this.observer.observe(this.productInfo);
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll, { passive: true });
      window.addEventListener('resize', StickyAtcPanel.handleScroll);
    }

    static handleScroll() {
      const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      const scrolledToBottom = window.scrollY + window.innerHeight + 100 > scrollHeight;

      document.body.classList.toggle('scrolled-to-bottom', scrolledToBottom);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
